import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import * as React from "react";
import { ReferentialItemDto } from "../../api";

import { useCommonHooks, useCountryRef } from "../../hooks";
import { ETLCodes } from "../../locales";
import { nameof } from "../../utils";

export interface ICountrySelectProps extends IFGSelectInputProps<any> {}

export const CountrySelect: React.FunctionComponent<ICountrySelectProps> = ({
  name,
  label,
  ...fgSelectInputProps
}) => {
  const { t } = useCommonHooks();
  const { countries, countriesLoading } = useCountryRef();

  return (
    <FGSelectInput
      label={label || t(ETLCodes.Country)}
      name={name}
      items={countries}
      loading={countriesLoading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};
